<template>
  <div>
    <v-switch
      class="mt-0"
      label="Efectivo"
      :input-value="paymentMethodEnabled(1, paymentMethod)"
      @change="togglePaymentMethod(1, type)"
      :disabled="paymentMethod === 1"
      dense
    />
    <v-switch
      class="mt-0"
      label="Tarjeta"
      :input-value="paymentMethodEnabled(2, paymentMethod)"
      @change="togglePaymentMethod(2, type)"
      :disabled="paymentMethod === 2"
      hint="Presencial"
      persistent-hint
      dense
    />
    <v-switch
      class="mt-0"
      label="QR"
      :input-value="paymentMethodEnabled(128, paymentMethod)"
      @change="togglePaymentMethod(128, type)"
      :disabled="paymentMethod === 128"
      hint="Presencial"
      persistent-hint
      dense
    />
    <v-switch
      class="mt-0"
      label="Transferencia"
      :input-value="paymentMethodEnabled(1024, paymentMethod)"
      @change="togglePaymentMethod(1024, type)"
      :disabled="paymentMethod === 1024"
      hint="Presencial"
      persistent-hint
      dense
    />
    <v-switch
      v-if="restaurant.country === 'AR'"
      class="mt-0"
      label="MercadoPago"
      :input-value="paymentMethodEnabled(4, paymentMethod)"
      @change="togglePaymentMethod(4, type)"
      :disabled="paymentMethod === 4 || editingBranch.ordersMode === 'wa'"
      :hint="
        editingBranch.ordersMode !== 'wa'
          ? 'Online'
          : 'No disponible en modo WhatsApp'
      "
      persistent-hint
      dense
    />
    <!-- <v-switch
      v-if="restaurant.country === 'ES'"
      class="mt-0"
      label="Tarjeta y Bizum"
      :input-value="paymentMethodEnabled(8, paymentMethod)"
      @change="togglePaymentMethod(8, type)"
      :disabled="paymentMethod === 8 || editingBranch.ordersMode === 'wa'"
      :hint="
        editingBranch.ordersMode !== 'wa'
          ? 'Online'
          : 'No disponible en modo WhatsApp'
      "
      persistent-hint
      dense
    />
    <v-switch
      v-if="restaurant.country === 'PA' && panamaTestId.includes(restaurant.id)"
      class="mt-0"
      label="Pago Online"
      :input-value="paymentMethodEnabled(64, paymentMethod)"
      @change="togglePaymentMethod(64, type)"
      :disabled="
        paymentMethod === 64 ||
        editingBranch.ordersMode === 'wa' ||
        panamaMobileStatus === 'pending'
      "
      :hint="
        panamaMobileStatus === 'pending'
          ? 'Pendiente de autorización'
          : editingBranch.ordersMode !== 'wa'
          ? 'Online'
          : 'No disponible en modo WhatsApp'
      "
      persistent-hint
      dense
    /> -->
  </div>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { Globals } from '../../modules/Globals';
  import { IBranch } from '../../interfaces/IBranch';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { PaymentMethod } from '../../enums/PaymentMethod';
  import { OrderType } from '../../enums/OrderEnums';
  import IVariable from '../../interfaces/IVariable';
  import RestaurantVariableCategory from '../../enums/RestaurantVariableCategory';

  @Component
  export default class PaymentMethodsToggles extends Vue {
    @Prop() editingBranch: IBranch;
    @Prop() restaurant: IRestaurant;
    @Prop() paymentMethod: PaymentMethod;
    @Prop() type: OrderType;
    @Prop() paymentMethodEnabled: boolean;
    @Prop() togglePaymentMethod: Function;
    @Prop() branchVariables: Array<IVariable<any>>;
  }
</script>
